export const adaptador_habitacion_mas_reserva = ({reserva, habitacion}) => {

    let obj = {
        ...reserva,
    }

    if (habitacion.id) {
        obj.idHabitacion = habitacion.id
        obj.numero = habitacion.numero
        obj.piso = habitacion.piso
        obj.tipo = habitacion.tipo
        obj.link = habitacion.link
    }


    return obj
}